export const INITIALIZE_VENUE = 'initialize-venue';
const initializeVenue = () => ({ type: INITIALIZE_VENUE });
export default initializeVenue;
